<template>
  <div class="footer dis-flex flex-x-between">
    <div
      class="item"
      v-for="item in list"
      :key="item.key"
      :class="{ on: item.urlNmae === routerName }"
      @click="toPage(item)"
    >
      <img
        :src="
          require(`@/assets/footer/${item.img}${
            item.urlNmae === routerName ? '-on' : ''
          }.png`)
        "
        alt=""
        class="img"
        :style="{ width: item.width, height: item.height }"
      />
      <div class="name">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    toPage(obj){
      this.$router.push({name:obj.urlNmae})
    }
  },
  created() {},
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    // $router(val){
    //   console.log(val)
    // }
  },
  computed: {
    routerName() {
      return this.$route.name;
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  position: fixed;
  bottom: 0;
  padding: 8px 0;
  box-sizing: border-box;
  text-align: center;
  background: #24292c;
  // box-shadow: 0px -3px 6px 1px rgba(0, 0, 0, 0.16);
  z-index: 999;
  .item {
    width: 33.33%;
    font-size: 0.8rem;
    color: #fff;
    // width: 50%;
    .img {
      width: 20px;
      height: 20px;
    }
  }
  .item.on {
    color: #7cb81d;
  }
}
</style>
